/** AspectRatioContainer parser: Control plus ratio, stretch_mode and alignment. */
import { parseOptionalFloat, parseOptionalInt } from '../../../../parser/valueParsers';
import { parseControl } from '../control/parser';
export function parseAspectRatioContainer(heading, properties) {
    const result = { ...parseControl(heading, properties) };
    result.ratio = parseOptionalFloat(properties.ratio);
    result.stretchMode = parseOptionalInt(properties.stretch_mode);
    result.alignmentHorizontal = parseOptionalInt(properties.alignment_horizontal);
    result.alignmentVertical = parseOptionalInt(properties.alignment_vertical);
    return result;
}
//# sourceMappingURL=parser.js.map